import axios from 'axios';
import { AsyncAction } from '.';
import { User } from '../types/user';

type State = {
    fetching: boolean;
    users: User[];
    error?: Error;
};

type Action = { type: 'users/get'; payload?: { users: User[] }; error?: Error };

const initialState: State = {
    fetching: false,
    users: [],
};

export const reducer = (state = initialState, action: Action): State => {
    if (action.type !== 'users/get') return state;
    if (action.payload) return { ...state, fetching: false, ...action.payload };
    if (action.error) return { ...state, fetching: false, error: action.error };
    return { ...state, fetching: true };
};

const get = (rethrow = false): AsyncAction => async dispatch => {
    try {
        dispatch({ type: 'users/get' });
        const cancel = axios.CancelToken.source();
        dispatch({ type: 'cancel/set', payload: { 'users/get': cancel } });
        const response = await axios.get<User[]>('/users/', { cancelToken: cancel.token });
        dispatch({ type: 'users/get', payload: { users: response.data } });
    } catch (error) {
        dispatch({ type: 'users/get', error });
        if (rethrow) throw error;
    }
};

export const creators = { get };
